/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import MatchDetailTable from "Common/Tables/MatchDetailTable";
import ShowFancyTable from "Common/Tables/ShowFancyTable";
import { FC, useEffect, useState } from "react";
import { Card, Tab, Nav } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { authServices } from "Utils/auth/services";
import { Data1Item } from "./DetailsLeft";
// import snackbarUtil from "Utils/snackBarUtil";
import { settingServices } from "Utils/setting/services";
import { AlertSelection } from "Common/Modals/AlertSetting";
import { currentDateTime, getStartTimeOfDay } from "Utils/datefilter";
import { useCallback } from "react";

interface Props {
  keys: string;
  mrkrtId?: any;
  rightv: boolean;
  useridType: any;
  matchedId?: string | undefined;
  alertData?: AlertSelection;
  show?: boolean;
}

const DetailsRight: FC<Props> = ({
  keys,
  mrkrtId,
  rightv,
  useridType,
  matchedId,
  alertData,
  show,
}) => {
  const [betsDetails, setBetDetails] = useState<BetsData>();
  const [betsDetailsFancy, setBetDetailsFancy] = useState<BetsData>();
  const [betsDetailsOdds, setBetDetailsOdds] = useState<BetsData>();
  const [betsDeleted, setBetDeleted] = useState<BetsData>();
  const [betsVoids, setBetsVoids] = useState<BetsData>();
  const [currentPage, setCurrentPage] = useState(1);
  const [isVoid, setIsVoid] = useState(false);
  const currentDate = new Date();
  const sevenDaysAgo = new Date(
    currentDate.setDate(currentDate.getDate() - 30)
  );
  const [startDate, setStartDate] = useState<string | Date>();
  const [endDate, setEndDate] = useState<string | Date>();
  const [fancyLiveData, setFancyLiveData] = useState<Data1Item[] | undefined>(
    undefined
  );
  const [formValuesFilter, setFormValuesFilter] = useState<{
    [key: string]: string;
  }>({});
  const [isFancy, setIsFancy] = useState(4);
  const [userNameData, setUserNameData] = useState<any[]>([]);
  const [user_name, setUser_name] = useState("");
  const [domainList, setDomainList] = useState<DomainListPayload[]>([]);
  const [domainId, setDomainId] = useState<string>("");

  const [paylodData, setPayloadData] = useState({
    bet_id: "",
    user_id: "",
    is_void: true,
    is_fancy: 0,
    password: "",
  });

  const [limit, setLimit] = useState<number>(50);
  const [listTotal, setListTotal] = useState<ProfitLossTotal>({
    total: 0,
    page: 0,
  });
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [betcount, setBetCount] = useState<number>(0);

  const { id, sportid } = useParams();

  function filterBets(
    bets: Dataaa[],
    alertSelection: AlertSelection
  ): Dataaa[] {
    const { min_amount, max_amount, min_bhav, users } = alertSelection;

    const minAmount = min_amount ? parseFloat(min_amount) : null;
    const maxAmount = max_amount ? parseFloat(max_amount) : null;
    const minBhav = min_bhav ? parseFloat(min_bhav) : null;
    const selectedUserIds = users.map((user) => user.value);

    return bets.filter((bet) => {
      const isUserMatch =
        selectedUserIds.length === 0 || selectedUserIds.includes(bet.user_id);
      const isMinAmountValid = minAmount === null || bet.stack >= minAmount;
      const isMaxAmountValid = maxAmount === null || bet.stack <= maxAmount;
      const isMinBhavValid = minBhav === null || bet.odds >= minBhav;

      return (
        isUserMatch && isMinAmountValid && isMaxAmountValid && isMinBhavValid
      );
    });
  }

  // const getBetsData = async (isBeep?: boolean) => {
  //   const {
  //     domain_name,
  //     market_name,
  //     is_back,
  //     odds,
  //     stack,
  //     bet_id,
  //     amount_from,
  //     amount_to,
  //   } = formValuesFilter;
  //   const searchQuery: any = {
  //     bet_result_id: { $eq: null },
  //     ...(isFancy !== 4 && { is_fancy: isFancy }),
  //     ...(user_name && { user_name }),
  //     ...(domainId &&
  //       domainId.length > 3 && {
  //         domain_name: domainId?.trim()?.toLowerCase(),
  //       }),
  //     ...(isDeleted && { delete_status: isVoid ? 2 : 1 }),
  //     ...(market_name && { selection_name: market_name }),
  //     ...(is_back && { is_back }),
  //     ...(bet_id && { ip_address: bet_id }),
  //     ...(odds && { odds }),
  //     ...(stack && { stack }),
  //     ...(Number(amount_to) > 0 && { amount_from: Number(amount_from) }),
  //     ...(Number(amount_to) > 0 && { amount_to: Number(amount_to) }),
  //     ...(stack && { stack }),
  //     ...(mrkrtId && !rightv && { [keys]: mrkrtId }),
  //   };
  //   const { response } = await authServices.getBets({
  //     match_id: id || matchedId || "",
  //     limit: limit,
  //     page: currentPage,
  //     search: searchQuery,
  //     from_date: startDate,
  //     to_date: endDate,
  //   });
  //   const betData = (response && response?.data) || [];
  //   if (betData && betData.metadata && betData.metadata.length > 0) {
  //     setListTotal({
  //       total: betData.metadata[0]?.total
  //         ? betData.metadata[0].total / limit
  //         : 0,
  //       page: betData.metadata[0]?.page || 0,
  //     });
  //   } else {
  //     setListTotal({
  //       total: 0,
  //       page: 0,
  //     });
  //   }

  //   let oldArray: Dataaa[] = [];
  //   if (isFancy === 0) {
  //     setBetDetailsOdds(betData);
  //     oldArray = betsDetailsOdds?.data || [];
  //   } else if (isFancy === 1) {
  //     setBetDetailsFancy(betData);
  //     oldArray = betsDetailsFancy?.data || [];
  //   } else if (isDeleted && isVoid) {
  //     setBetsVoids(betData);
  //   } else if (isDeleted) {
  //     setBetDeleted(betData);
  //   } else {
  //     setBetDetails(betData);
  //     oldArray = betsDetails?.data || [];
  //   }

  //   if (betData && betData.metadata && betData.metadata.length > 0) {
  //     const oldBetIds = new Set(oldArray.map((item) => item.bet_id));
  //     const newBetIdsNotInOld = betData?.data.filter(
  //       (item: Dataaa) => !oldBetIds.has(item.bet_id)
  //     );
  //     if (newBetIdsNotInOld?.length > 0) {
  //       let isAllowed = alertData
  //         ? filterBets(newBetIdsNotInOld, alertData)
  //         : [];

  //       if (
  //         alertData &&
  //         alertData?.isAlert &&
  //         isAllowed?.length > 0 &&
  //         isBeep
  //       ) {
  //         beepOnce();
  //       }
  //     }

  //     if (betData?.metadata[0]?.total !== betcount) {
  //       setBetCount(betData?.metadata[0]?.total);
  //     }
  //   }
  // };

  const getBetsData = useCallback(
    async (isBeep = false) => {
      const {
        domain_name,
        market_name,
        is_back,
        odds,
        stack,
        bet_id,
        amount_from,
        amount_to,
      } = formValuesFilter;

      const searchQuery = {
        bet_result_id: { $eq: null },
        ...(isFancy !== 4 && { is_fancy: isFancy }),
        ...(user_name && { user_name }),
        ...(domainId?.length > 3 && {
          domain_name: domainId.trim().toLowerCase(),
        }),
        ...(isDeleted && { delete_status: isVoid ? 2 : 1 }),
        ...(market_name && { selection_name: market_name }),
        ...(is_back && { is_back }),
        ...(bet_id && { ip_address: bet_id }),
        ...(odds && { odds }),
        ...(stack && { stack }),
        ...(Number(amount_to) > 0 && { amount_from: Number(amount_from) }),
        ...(Number(amount_to) > 0 && { amount_to: Number(amount_to) }),
        ...(mrkrtId && !rightv && { [keys]: mrkrtId }),
      };

      const payload: any = {
        match_id: id || matchedId || "",
        limit,
        page: currentPage,
        search: searchQuery,
      };

      if (startDate) {
        payload.from_date = startDate;
      }

      if (endDate) {
        payload.to_date = endDate;
      }

      const { response } = await authServices.getBets(payload);

      const betData = response?.data || [];
      const meta = betData?.metadata?.[0];

      if (meta) {
        setListTotal({
          total: meta.total ? meta.total / limit : 0,
          page: meta.page || 0,
        });
      } else {
        setListTotal({ total: 0, page: 0 });
      }

      let oldArray: Dataaa[] = [];
      if (isFancy === 0) {
        setBetDetailsOdds(betData);
        oldArray = betsDetailsOdds?.data || [];
      } else if (isFancy === 1) {
        setBetDetailsFancy(betData);
        oldArray = betsDetailsFancy?.data || [];
      } else if (isDeleted && isVoid) {
        setBetsVoids(betData);
      } else if (isDeleted) {
        setBetDeleted(betData);
      } else {
        setBetDetails(betData);
        oldArray = betsDetails?.data || [];
      }

      if (meta) {
        const oldBetIds = new Set(oldArray.map((item) => item.bet_id));
        const newBets = betData?.data?.filter(
          (item: any) => !oldBetIds.has(item.bet_id)
        );
        const validAlerts: any = alertData && filterBets(newBets, alertData);

        if (alertData?.isAlert && validAlerts?.length > 0 && isBeep) beepOnce();
        if (meta.total !== betcount) setBetCount(meta.total);
      }
    },
    [
      id,
      matchedId,
      mrkrtId,
      rightv,
      keys,
      limit,
      currentPage,
      formValuesFilter,
      isFancy,
      user_name,
      domainId,
      isDeleted,
      isVoid,
      startDate,
      endDate,
      alertData,
      betcount,
      betsDetails,
      betsDetailsFancy,
      betsDetailsOdds,
    ]
  );

  const getFancyLiveData = async () => {
    const { response } = await authServices.getOnlineFancy({
      match_id: id || "",
    });
    setFancyLiveData(response?.data);
  };

  const beepOnce = () => {
    const audio = new Audio("/beep/beep.mp3");
    audio?.play().catch((error) => {
      console.error("Playback failed:", error);
    });
    setTimeout(() => {
      audio.pause();
    }, 2000);
  };

  const getUserbyUserName = async (user_name: string) => {
    const { response } = await settingServices.getUserbyUserName({
      user_name: user_name?.trim()?.toLowerCase(),
    });
    const options = response?.data.map((user: any) => ({
      value: user?.user_name,
      label: user?.user_name,
    }));
    setUserNameData(options);
  };

  const handleSelectUser = (selectedOption: any) => {
    if (selectedOption) {
      setUser_name(selectedOption.value);
    }
  };

  const handleUser = (inputValue: string) => {
    if (inputValue?.length > 3) {
      getUserbyUserName(inputValue);
    }
  };

  const getAllWebsite = async () => {
    const { response } = await authServices.getAllWebsite();
    const options = response?.data.map((user: any) => ({
      value: user?.domain_name,
      label: user.host_name,
    }));
    setDomainList(options);
  };

  const [userCount, setUserCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const getTotalUserCount = async () => {
    const { response } = await authServices.getTotalUserCount({
      format_type: "MARKET_WISE",
      match_id: id || "",
    });

    setTotalCount(response?.data?.result?.[0]?.users_count);
  };
  const getActiveUserCount = async () => {
    const { response } = await authServices.getActiveUserCount({
      format_type: "MARKET_WISE",
      match_id: id || "",
    });
    setUserCount(response?.data?.result?.[0]?.users_count);
  };

  useEffect(() => {
    getAllWebsite();
  }, []);

  useEffect(() => {
    if (id) {
      getTotalUserCount();
      getActiveUserCount();
    }
  }, [id]);

  const handleDomain = (selectedOption: any) => {
    setCurrentPage(1);
    const selectedValue = selectedOption ? selectedOption.value : "";
    setDomainId(selectedValue);
  };

  const handleAll = () => {
    setCurrentPage(1);
    setIsFancy(4);
    setIsDeleted(false);
  };

  const handleMatchedBet = () => {
    setCurrentPage(1);
    setIsFancy(0);
    setIsDeleted(false);
  };

  const handleFancyBet = () => {
    setCurrentPage(1);
    setIsFancy(1);
    setIsDeleted(false);
  };
  const handleDeleteBet = (delete_status: boolean, isV: boolean) => {
    setCurrentPage(1);
    setIsFancy(4);
    setIsVoid(isV);
    setIsDeleted(true);
  };

  const handlePageFilter = (page: number, limit: number) => {
    setCurrentPage(page);
    setLimit(limit);
  };

  const showFancy = () => {
    setIsDeleted(false);
    getFancyLiveData();
  };

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    getBetsData(!show); 

    if (!show) {
      intervalId = setInterval(() => {
        getBetsData(true); // enable beep on repeated calls
      }, 800);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [
    show,
    id,
    currentPage,
    limit,
    formValuesFilter,
    isFancy,
    user_name,
    domainId,
    isDeleted,
    betcount,
    alertData,
    isVoid,
    startDate,
    endDate,
  ]);

  return (
    <Card
      className="p-3 overflow-auto position-sticky end-0 tab_match_details"
      style={{
        maxHeight: "calc(100vh - 105px)",
        top: "90px",
        display: "block",
      }}
    >
      <Tab.Container defaultActiveKey="all">
        {rightv && (
          <Nav
            as="ul"
            variant="pills"
            className="arrow-navtabs nav-primary bg-light"
          >
            <Nav.Item as="li" className="mx-2">
              <Nav.Link className="px-2" eventKey="all" onClick={handleAll}>
                All Bet{" "}
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary shadow-lg">
                  {(betsDetails?.metadata && betsDetails?.metadata[0]?.total) ||
                    0}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li" className="mx-2">
              <Nav.Link
                className="px-2"
                eventKey="match"
                onClick={() => handleMatchedBet()}
              >
                Match Bet{" "}
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary shadow-lg">
                  {(betsDetailsOdds?.metadata &&
                    betsDetailsOdds?.metadata[0]?.total) ||
                    0}
                </span>
              </Nav.Link>
            </Nav.Item>
            {Number(sportid) === 4 && (
              <>
                <Nav.Item as="li" className="mx-2">
                  <Nav.Link
                    className="px-2"
                    eventKey="fancy"
                    onClick={() => handleFancyBet()}
                  >
                    Fancy Bet{" "}
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary shadow-lg">
                      {(betsDetailsFancy?.metadata &&
                        betsDetailsFancy?.metadata[0]?.total) ||
                        0}
                    </span>
                  </Nav.Link>
                </Nav.Item>
              </>
            )}
            {useridType === 0 && (
              <Nav.Item as="li" className="mx-2">
                <Nav.Link
                  className="px-2"
                  eventKey="delete"
                  onClick={() => handleDeleteBet(true, false)}
                >
                  Deleted Bet{" "}
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary shadow-lg">
                    {(betsDeleted?.metadata &&
                      betsDeleted?.metadata[0]?.total) ||
                      0}
                  </span>
                </Nav.Link>
              </Nav.Item>
            )}
            {useridType === 0 && (
              <Nav.Item as="li" className="mx-2">
                <Nav.Link
                  className="px-2"
                  eventKey="void"
                  onClick={() => handleDeleteBet(true, true)}
                >
                  Void Bet{" "}
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary shadow-lg">
                    {(betsVoids?.metadata && betsVoids?.metadata[0]?.total) ||
                      0}
                  </span>
                </Nav.Link>
              </Nav.Item>
            )}
            {Number(sportid) === 4 &&
              (useridType === 0 || useridType === 8) && (
                <>
                  <Nav.Item as="li" className="mx-2">
                    <Nav.Link
                      className="px-2"
                      eventKey="show"
                      onClick={showFancy}
                    >
                      Show Fancy{" "}
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary shadow-lg">
                        {fancyLiveData?.length}
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                </>
              )}
            {useridType === 0 && (
              <Nav.Item as="li" className="mx-2">
                <Nav.Link
                  className="px-2"
                  eventKey="user_count"
                  onClick={() => getTotalUserCount()}
                >
                  User Count ({totalCount || 0})
                </Nav.Link>
              </Nav.Item>
            )}
            {useridType === 0 && (
              <Nav.Item as="li" className="mx-2">
                <Nav.Link
                  className="px-2"
                  eventKey="total_count"
                  onClick={() => getActiveUserCount()}
                >
                  Live User ({userCount || 0})
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>
        )}
        <Tab.Content className="text-muted">
          <Tab.Pane eventKey="all">
            <MatchDetailTable
              betsDetails={betsDetails}
              getBetsData={getBetsData}
              setPayloadData={setPayloadData}
              paylodData={paylodData}
              currentPage={currentPage}
              handleUser={handleUser}
              formValuesFilter={formValuesFilter}
              setFormValuesFilter={(value: any) => {
                setCurrentPage(1);
                setFormValuesFilter(value);
              }}
              page={currentPage}
              limit={limit}
              listTotal={listTotal}
              handlePageFilter={handlePageFilter}
              userNameData={userNameData}
              userName={user_name}
              handleSelectUser={handleSelectUser}
              setUser_name={setUser_name}
              useridType={useridType}
              domainList={domainList}
              domainId={domainId}
              handleDomain={handleDomain}
              betcount={betcount}
              setStartDate={setStartDate}
              startDate={startDate}
              setEndDate={setEndDate}
              endDate={endDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="user_count">
            <MatchDetailTable
              betsDetails={betsDetails}
              getBetsData={getBetsData}
              setPayloadData={setPayloadData}
              paylodData={paylodData}
              currentPage={currentPage}
              handleUser={handleUser}
              formValuesFilter={formValuesFilter}
              setFormValuesFilter={(value: any) => {
                setCurrentPage(1);
                setFormValuesFilter(value);
              }}
              page={currentPage}
              limit={limit}
              listTotal={listTotal}
              handlePageFilter={handlePageFilter}
              userNameData={userNameData}
              userName={user_name}
              handleSelectUser={handleSelectUser}
              setUser_name={setUser_name}
              useridType={useridType}
              domainList={domainList}
              domainId={domainId}
              handleDomain={handleDomain}
              betcount={betcount}
              setStartDate={setStartDate}
              startDate={startDate}
              setEndDate={setEndDate}
              endDate={endDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="total_count">
            <MatchDetailTable
              betsDetails={betsDetails}
              getBetsData={getBetsData}
              setPayloadData={setPayloadData}
              paylodData={paylodData}
              currentPage={currentPage}
              handleUser={handleUser}
              formValuesFilter={formValuesFilter}
              setFormValuesFilter={(value: any) => {
                setCurrentPage(1);
                setFormValuesFilter(value);
              }}
              page={currentPage}
              limit={limit}
              listTotal={listTotal}
              handlePageFilter={handlePageFilter}
              userNameData={userNameData}
              userName={user_name}
              handleSelectUser={handleSelectUser}
              setUser_name={setUser_name}
              useridType={useridType}
              domainList={domainList}
              domainId={domainId}
              handleDomain={handleDomain}
              betcount={betcount}
              setStartDate={setStartDate}
              startDate={startDate}
              setEndDate={setEndDate}
              endDate={endDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="match">
            <MatchDetailTable
              betsDetails={betsDetailsOdds}
              getBetsData={getBetsData}
              setPayloadData={setPayloadData}
              paylodData={paylodData}
              currentPage={currentPage}
              handleUser={handleUser}
              formValuesFilter={formValuesFilter}
              setFormValuesFilter={(value: any) => {
                setCurrentPage(1);
                setFormValuesFilter(value);
              }}
              page={currentPage}
              limit={limit}
              listTotal={listTotal}
              handlePageFilter={handlePageFilter}
              userNameData={userNameData}
              userName={user_name}
              handleSelectUser={handleSelectUser}
              setUser_name={setUser_name}
              useridType={useridType}
              domainList={domainList}
              domainId={domainId}
              handleDomain={handleDomain}
              betcount={betcount}
              setStartDate={setStartDate}
              startDate={startDate}
              setEndDate={setEndDate}
              endDate={endDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="delete">
            <MatchDetailTable
              betsDetails={betsDeleted}
              getBetsData={getBetsData}
              setPayloadData={setPayloadData}
              paylodData={paylodData}
              currentPage={currentPage}
              handleUser={handleUser}
              userNameData={userNameData}
              userName={user_name}
              formValuesFilter={formValuesFilter}
              setFormValuesFilter={(value: any) => {
                setCurrentPage(1);
                setFormValuesFilter(value);
              }}
              page={currentPage}
              limit={limit}
              listTotal={listTotal}
              handlePageFilter={handlePageFilter}
              handleSelectUser={handleSelectUser}
              setUser_name={setUser_name}
              useridType={useridType}
              domainList={domainList}
              domainId={domainId}
              handleDomain={handleDomain}
              betcount={betcount}
              setStartDate={setStartDate}
              startDate={startDate}
              setEndDate={setEndDate}
              endDate={endDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="void">
            <MatchDetailTable
              betsDetails={betsVoids}
              getBetsData={getBetsData}
              setPayloadData={setPayloadData}
              paylodData={paylodData}
              currentPage={currentPage}
              handleUser={handleUser}
              formValuesFilter={formValuesFilter}
              setFormValuesFilter={(value: any) => {
                setCurrentPage(1);
                setFormValuesFilter(value);
              }}
              page={currentPage}
              limit={limit}
              listTotal={listTotal}
              handlePageFilter={handlePageFilter}
              userNameData={userNameData}
              userName={user_name}
              handleSelectUser={handleSelectUser}
              setUser_name={setUser_name}
              useridType={useridType}
              domainList={domainList}
              domainId={domainId}
              handleDomain={handleDomain}
              betcount={betcount}
              setStartDate={setStartDate}
              startDate={startDate}
              setEndDate={setEndDate}
              endDate={endDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="fancy">
            <MatchDetailTable
              betsDetails={betsDetailsFancy}
              getBetsData={getBetsData}
              setPayloadData={setPayloadData}
              paylodData={paylodData}
              currentPage={currentPage}
              userNameData={userNameData}
              handleUser={handleUser}
              userName={user_name}
              formValuesFilter={formValuesFilter}
              setFormValuesFilter={(value: any) => {
                setCurrentPage(1);
                setFormValuesFilter(value);
              }}
              page={currentPage}
              limit={limit}
              listTotal={listTotal}
              handlePageFilter={handlePageFilter}
              handleSelectUser={handleSelectUser}
              setUser_name={setUser_name}
              useridType={useridType}
              domainList={domainList}
              domainId={domainId}
              handleDomain={handleDomain}
              betcount={betcount}
              setStartDate={setStartDate}
              startDate={startDate}
              setEndDate={setEndDate}
              endDate={endDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="show">
            <ShowFancyTable
              data={fancyLiveData}
              getFancyLiveData={getFancyLiveData}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Card>
  );
};

export default DetailsRight;
